import { render, staticRenderFns } from "./SearchbannerPhone.vue?vue&type=template&id=071c2391&scoped=true&"
import script from "./SearchbannerPhone.vue?vue&type=script&lang=js&"
export * from "./SearchbannerPhone.vue?vue&type=script&lang=js&"
import style0 from "./SearchbannerPhone.vue?vue&type=style&index=0&id=071c2391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c2391",
  null
  
)

export default component.exports